import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { Layout } from './Layout';
import { InquiryListHeader } from '../organisms/InquiryListHeader';
import { InquiryList } from '../organisms/InquiryList';

const StyledDiv = styled.div`
  background-color: #fff;
`;

export const InquiryListPage = observer(() => {
  return (
    <Layout>
      <InquiryListHeader />
      <div className="ri-inquiry-contents  _list">
        <StyledDiv>
          <InquiryList />
        </StyledDiv>
      </div>
    </Layout>
  );
});
